import { IUpdateFornecedorDocumentoUseCase } from "../../../presentation/useCases/update/update_fornecedor_documento_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * UpdateFornecedorDocumentoUseCase
 */

export class UpdateFornecedorDocumentoUseCase implements IUpdateFornecedorDocumentoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async updateFornecedorDocumento(
    idFornecedor: number,
    idFornecedorArquivo: number,
    statusArquivo: number,
    nomeDocumento: string,
    dataVencimento: Date | null,
    file: File | null,
    limparArquivo: boolean,
  ): Promise<void> {
    await this.repository.updateFornecedorDocumento(
      idFornecedor,
      idFornecedorArquivo,
      statusArquivo,
      nomeDocumento,
      dataVencimento,
      file,
      limparArquivo,
    );
  }
}
